"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var _default = nodejsCustomInspectSymbol;
exports.default = _default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-appsync/node_modules/apollo-client/node_modules/apollo-link/node_modules/graphql/jsutils/nodejsCustomInspectSymbol.js
// module id = 1243
// module chunks = 3